/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type EntityActivityKind = "EDUCATIONAL" | "GOVERNMENT_AGENCY" | "NON_PROFIT" | "PARTNERSHIP" | "PRIVATELY_HELD" | "PUBLIC_COMPANY" | "SELF_EMPLOYED" | "SELF_OWNED" | "%future added value";
export type MediaAssetFileStatusKind = "AVAILABLE" | "CREATED" | "DELETED" | "ERROR" | "PROCESSING" | "%future added value";
export type MediaAssetStateKind = "AVAILABLE" | "CREATED" | "DELETED" | "PROCESSING" | "%future added value";
export type PreviewKind = "A_ROLE" | "BACKGROUND" | "BADGE_DARK" | "BADGE_LIGHT" | "B_ROLE" | "CAROUSEL" | "DETAIL_BACKGROUND" | "EXCERPT" | "HEADSHOT" | "HERO" | "HERO_LOGO" | "LOGO" | "PORTRAIT" | "SQUARE" | "%future added value";
export type TopLevelMediaKind = "APPLICATION" | "AUDIO" | "DOCUMENT" | "IMAGE" | "TEXT" | "VIDEO" | "%future added value";
export type storyQueryVariables = {
    readonly id: string;
};
export type storyQueryResponse = {
    readonly story: {
        readonly hasErrors: boolean | null;
        readonly errors: ReadonlyArray<{
            readonly id: string;
            readonly location: string | null;
        } | null> | null;
        readonly node: ({
            readonly __typename: "PitchVideoStory";
            readonly id?: string;
            readonly revision?: string | null;
            readonly description?: string | null;
            readonly title?: string | null;
            readonly subTitle?: string | null;
            readonly isPromoted?: boolean | null;
            readonly created?: unknown | null;
            readonly label?: string | null;
            readonly isDeleted?: boolean | null;
            readonly isNew?: boolean | null;
            readonly trailer?: {
                readonly externalId: string | null;
                readonly description: string | null;
                readonly durationInSeconds: number | null;
                readonly link: string | null;
            } | null;
            readonly originalClip?: {
                readonly externalId: string | null;
                readonly durationInSeconds: number | null;
                readonly description: string | null;
                readonly link: string | null;
            } | null;
            readonly peopleEntities?: ReadonlyArray<{
                readonly entity: {
                    readonly __typename: string;
                    readonly landingPageUrl: string | null;
                    readonly id: string;
                    readonly name: string | null;
                    readonly websiteUrl: string | null;
                    readonly industry: string | null;
                    readonly fundingRound: string | null;
                    readonly activities: ReadonlyArray<{
                        readonly kind: EntityActivityKind | null;
                        readonly label: string | null;
                    }> | null;
                    readonly people: {
                        readonly count: number | null;
                        readonly edges: ReadonlyArray<{
                            readonly role: string | null;
                            readonly person: {
                                readonly __typename: string;
                                readonly id: string;
                                readonly fullName: string | null;
                                readonly landingPageUrl: string | null;
                                readonly previews: {
                                    readonly edges: ReadonlyArray<{
                                        readonly preview: {
                                            readonly link: string | null;
                                            readonly kind: PreviewKind | null;
                                            readonly mediaAsset: {
                                                readonly files: ReadonlyArray<{
                                                    readonly name: string | null;
                                                    readonly path: string | null;
                                                }> | null;
                                                readonly topLevelMediaType: {
                                                    readonly kind: TopLevelMediaKind | null;
                                                } | null;
                                            } | null;
                                        } | null;
                                    }> | null;
                                } | null;
                            };
                        }> | null;
                    } | null;
                    readonly investmentsBy: ReadonlyArray<{
                        readonly amount: string | null;
                        readonly link: string | null;
                        readonly deckUrl: string | null;
                        readonly investmentDate: unknown | null;
                    }> | null;
                    readonly previews: {
                        readonly count: number | null;
                        readonly edges: ReadonlyArray<{
                            readonly cursor: string | null;
                            readonly preview: {
                                readonly mediaAsset: {
                                    readonly id: string;
                                    readonly files: ReadonlyArray<{
                                        readonly id: string;
                                        readonly name: string | null;
                                        readonly heightInPixels: number | null;
                                        readonly widthInPixels: number | null;
                                        readonly path: string | null;
                                        readonly status: {
                                            readonly kind: MediaAssetFileStatusKind | null;
                                        } | null;
                                    }> | null;
                                    readonly state: {
                                        readonly kind: MediaAssetStateKind | null;
                                    } | null;
                                    readonly topLevelMediaType: {
                                        readonly kind: TopLevelMediaKind | null;
                                    } | null;
                                } | null;
                                readonly kind: PreviewKind | null;
                                readonly link: string | null;
                            } | null;
                        }> | null;
                    } | null;
                } | null;
                readonly person: {
                    readonly __typename: string;
                    readonly landingPageUrl: string | null;
                    readonly id: string;
                    readonly fullName: string | null;
                    readonly responsibility: string | null;
                    readonly description: string | null;
                    readonly previews: {
                        readonly count: number | null;
                        readonly edges: ReadonlyArray<{
                            readonly cursor: string | null;
                            readonly preview: {
                                readonly mediaAsset: {
                                    readonly id: string;
                                    readonly files: ReadonlyArray<{
                                        readonly id: string;
                                        readonly name: string | null;
                                        readonly heightInPixels: number | null;
                                        readonly widthInPixels: number | null;
                                        readonly path: string | null;
                                        readonly status: {
                                            readonly kind: MediaAssetFileStatusKind | null;
                                        } | null;
                                    }> | null;
                                    readonly state: {
                                        readonly kind: MediaAssetStateKind | null;
                                    } | null;
                                    readonly topLevelMediaType: {
                                        readonly kind: TopLevelMediaKind | null;
                                    } | null;
                                } | null;
                                readonly kind: PreviewKind | null;
                                readonly link: string | null;
                            } | null;
                        }> | null;
                    } | null;
                } | null;
            }> | null;
            readonly previews?: {
                readonly count: number | null;
                readonly edges: ReadonlyArray<{
                    readonly cursor: string | null;
                    readonly preview: {
                        readonly mediaAsset: {
                            readonly id: string;
                            readonly files: ReadonlyArray<{
                                readonly id: string;
                                readonly name: string | null;
                                readonly heightInPixels: number | null;
                                readonly widthInPixels: number | null;
                                readonly path: string | null;
                                readonly status: {
                                    readonly kind: MediaAssetFileStatusKind | null;
                                } | null;
                            }> | null;
                            readonly state: {
                                readonly kind: MediaAssetStateKind | null;
                            } | null;
                            readonly topLevelMediaType: {
                                readonly kind: TopLevelMediaKind | null;
                            } | null;
                        } | null;
                        readonly kind: PreviewKind | null;
                        readonly link: string | null;
                    } | null;
                }> | null;
            } | null;
            readonly landingPageUrl?: string | null;
            readonly durationInSeconds?: number | null;
            readonly sourceList?: string | null;
            readonly externalId?: string | null;
            readonly link?: string | null;
            readonly lastModified?: unknown | null;
            readonly moreLikeThis?: string | null;
            readonly badges?: ReadonlyArray<{
                readonly imageLink: string | null;
                readonly link: string | null;
                readonly previews: {
                    readonly count: number | null;
                    readonly edges: ReadonlyArray<{
                        readonly cursor: string | null;
                        readonly preview: {
                            readonly mediaAsset: {
                                readonly id: string;
                                readonly files: ReadonlyArray<{
                                    readonly id: string;
                                    readonly name: string | null;
                                    readonly heightInPixels: number | null;
                                    readonly widthInPixels: number | null;
                                    readonly path: string | null;
                                    readonly status: {
                                        readonly kind: MediaAssetFileStatusKind | null;
                                    } | null;
                                }> | null;
                                readonly state: {
                                    readonly kind: MediaAssetStateKind | null;
                                } | null;
                                readonly topLevelMediaType: {
                                    readonly kind: TopLevelMediaKind | null;
                                } | null;
                            } | null;
                            readonly kind: PreviewKind | null;
                            readonly link: string | null;
                        } | null;
                    }> | null;
                } | null;
            }> | null;
            readonly entities?: ReadonlyArray<{
                readonly description: string | null;
                readonly id: string;
                readonly name: string | null;
            }> | null;
            readonly mediaItem?: {
                readonly durationInMilliseconds: number | null;
                readonly files: ReadonlyArray<{
                    readonly heightInPixels: number | null;
                    readonly widthInPixels: number | null;
                    readonly name: string | null;
                    readonly path: string | null;
                }> | null;
                readonly topLevelMediaType: {
                    readonly kind: TopLevelMediaKind | null;
                } | null;
            } | null;
            readonly people?: ReadonlyArray<{
                readonly id: string;
                readonly fullName: string | null;
                readonly responsibility: string | null;
            }> | null;
            readonly origContentTags?: ReadonlyArray<{
                readonly id: string;
                readonly label: string | null;
            }> | null;
            readonly publisher?: string | null;
            readonly publishedDate?: unknown | null;
            readonly timeToReadInSeconds?: number | null;
            readonly cost?: string | null;
            readonly timeRequiredInSeconds?: number | null;
            readonly content?: string | null;
        } & ({
            readonly __typename: "PitchVideoStory";
            readonly id: string;
            readonly revision: string | null;
            readonly description: string | null;
            readonly title: string | null;
            readonly subTitle: string | null;
            readonly isPromoted: boolean | null;
            readonly created: unknown | null;
            readonly label: string | null;
            readonly isDeleted: boolean | null;
            readonly isNew: boolean | null;
            readonly trailer: {
                readonly externalId: string | null;
                readonly description: string | null;
                readonly durationInSeconds: number | null;
                readonly link: string | null;
            } | null;
            readonly originalClip: {
                readonly externalId: string | null;
                readonly durationInSeconds: number | null;
                readonly description: string | null;
                readonly link: string | null;
            } | null;
            readonly peopleEntities: ReadonlyArray<{
                readonly entity: {
                    readonly __typename: string;
                    readonly landingPageUrl: string | null;
                    readonly id: string;
                    readonly name: string | null;
                    readonly websiteUrl: string | null;
                    readonly industry: string | null;
                    readonly fundingRound: string | null;
                    readonly activities: ReadonlyArray<{
                        readonly kind: EntityActivityKind | null;
                        readonly label: string | null;
                    }> | null;
                    readonly people: {
                        readonly count: number | null;
                        readonly edges: ReadonlyArray<{
                            readonly role: string | null;
                            readonly person: {
                                readonly __typename: string;
                                readonly id: string;
                                readonly fullName: string | null;
                                readonly landingPageUrl: string | null;
                                readonly previews: {
                                    readonly edges: ReadonlyArray<{
                                        readonly preview: {
                                            readonly link: string | null;
                                            readonly kind: PreviewKind | null;
                                            readonly mediaAsset: {
                                                readonly files: ReadonlyArray<{
                                                    readonly name: string | null;
                                                    readonly path: string | null;
                                                }> | null;
                                                readonly topLevelMediaType: {
                                                    readonly kind: TopLevelMediaKind | null;
                                                } | null;
                                            } | null;
                                        } | null;
                                    }> | null;
                                } | null;
                            };
                        }> | null;
                    } | null;
                    readonly investmentsBy: ReadonlyArray<{
                        readonly amount: string | null;
                        readonly link: string | null;
                        readonly deckUrl: string | null;
                        readonly investmentDate: unknown | null;
                    }> | null;
                    readonly previews: {
                        readonly count: number | null;
                        readonly edges: ReadonlyArray<{
                            readonly cursor: string | null;
                            readonly preview: {
                                readonly mediaAsset: {
                                    readonly id: string;
                                    readonly files: ReadonlyArray<{
                                        readonly id: string;
                                        readonly name: string | null;
                                        readonly heightInPixels: number | null;
                                        readonly widthInPixels: number | null;
                                        readonly path: string | null;
                                        readonly status: {
                                            readonly kind: MediaAssetFileStatusKind | null;
                                        } | null;
                                    }> | null;
                                    readonly state: {
                                        readonly kind: MediaAssetStateKind | null;
                                    } | null;
                                    readonly topLevelMediaType: {
                                        readonly kind: TopLevelMediaKind | null;
                                    } | null;
                                } | null;
                                readonly kind: PreviewKind | null;
                                readonly link: string | null;
                            } | null;
                        }> | null;
                    } | null;
                } | null;
                readonly person: {
                    readonly __typename: string;
                    readonly landingPageUrl: string | null;
                    readonly id: string;
                    readonly fullName: string | null;
                    readonly responsibility: string | null;
                    readonly description: string | null;
                    readonly previews: {
                        readonly count: number | null;
                        readonly edges: ReadonlyArray<{
                            readonly cursor: string | null;
                            readonly preview: {
                                readonly mediaAsset: {
                                    readonly id: string;
                                    readonly files: ReadonlyArray<{
                                        readonly id: string;
                                        readonly name: string | null;
                                        readonly heightInPixels: number | null;
                                        readonly widthInPixels: number | null;
                                        readonly path: string | null;
                                        readonly status: {
                                            readonly kind: MediaAssetFileStatusKind | null;
                                        } | null;
                                    }> | null;
                                    readonly state: {
                                        readonly kind: MediaAssetStateKind | null;
                                    } | null;
                                    readonly topLevelMediaType: {
                                        readonly kind: TopLevelMediaKind | null;
                                    } | null;
                                } | null;
                                readonly kind: PreviewKind | null;
                                readonly link: string | null;
                            } | null;
                        }> | null;
                    } | null;
                } | null;
            }> | null;
            readonly previews: {
                readonly count: number | null;
                readonly edges: ReadonlyArray<{
                    readonly cursor: string | null;
                    readonly preview: {
                        readonly mediaAsset: {
                            readonly id: string;
                            readonly files: ReadonlyArray<{
                                readonly id: string;
                                readonly name: string | null;
                                readonly heightInPixels: number | null;
                                readonly widthInPixels: number | null;
                                readonly path: string | null;
                                readonly status: {
                                    readonly kind: MediaAssetFileStatusKind | null;
                                } | null;
                            }> | null;
                            readonly state: {
                                readonly kind: MediaAssetStateKind | null;
                            } | null;
                            readonly topLevelMediaType: {
                                readonly kind: TopLevelMediaKind | null;
                            } | null;
                        } | null;
                        readonly kind: PreviewKind | null;
                        readonly link: string | null;
                    } | null;
                }> | null;
            } | null;
        } | {
            readonly landingPageUrl: string | null;
            readonly durationInSeconds: number | null;
            readonly sourceList: string | null;
            readonly externalId: string | null;
            readonly link: string | null;
            readonly lastModified: unknown | null;
            readonly moreLikeThis: string | null;
            readonly badges: ReadonlyArray<{
                readonly imageLink: string | null;
                readonly link: string | null;
                readonly previews: {
                    readonly count: number | null;
                    readonly edges: ReadonlyArray<{
                        readonly cursor: string | null;
                        readonly preview: {
                            readonly mediaAsset: {
                                readonly id: string;
                                readonly files: ReadonlyArray<{
                                    readonly id: string;
                                    readonly name: string | null;
                                    readonly heightInPixels: number | null;
                                    readonly widthInPixels: number | null;
                                    readonly path: string | null;
                                    readonly status: {
                                        readonly kind: MediaAssetFileStatusKind | null;
                                    } | null;
                                }> | null;
                                readonly state: {
                                    readonly kind: MediaAssetStateKind | null;
                                } | null;
                                readonly topLevelMediaType: {
                                    readonly kind: TopLevelMediaKind | null;
                                } | null;
                            } | null;
                            readonly kind: PreviewKind | null;
                            readonly link: string | null;
                        } | null;
                    }> | null;
                } | null;
            }> | null;
            readonly entities: ReadonlyArray<{
                readonly description: string | null;
                readonly id: string;
                readonly name: string | null;
            }> | null;
            readonly mediaItem: {
                readonly durationInMilliseconds: number | null;
                readonly files: ReadonlyArray<{
                    readonly heightInPixels: number | null;
                    readonly widthInPixels: number | null;
                    readonly name: string | null;
                    readonly path: string | null;
                }> | null;
                readonly topLevelMediaType: {
                    readonly kind: TopLevelMediaKind | null;
                } | null;
            } | null;
            readonly people: ReadonlyArray<{
                readonly id: string;
                readonly fullName: string | null;
                readonly responsibility: string | null;
            }> | null;
            readonly origContentTags: ReadonlyArray<{
                readonly id: string;
                readonly label: string | null;
            }> | null;
        } | {
            readonly publisher: string | null;
        } | {
            readonly publishedDate: unknown | null;
            readonly timeToReadInSeconds: number | null;
        } | {
            readonly cost: string | null;
            readonly timeRequiredInSeconds: number | null;
        } | {
            readonly content: string | null;
        } | {
            /*This will never be '% other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        })) | null;
    } | null;
};
export type storyQuery = {
    readonly response: storyQueryResponse;
    readonly variables: storyQueryVariables;
};



/*
query storyQuery(
  $id: ID!
) {
  story(id: $id) {
    hasErrors
    errors {
      id
      location
    }
    node {
      __typename
      ... on PitchVideoStory {
        __typename
        id
        revision
        description
        title
        subTitle
        isPromoted
        created
        label
        isDeleted
        isNew
        trailer {
          externalId
          description
          durationInSeconds
          link
        }
        originalClip {
          externalId
          durationInSeconds
          description
          link
        }
        peopleEntities {
          entity {
            __typename
            landingPageUrl
            id
            name
            websiteUrl
            industry
            fundingRound
            activities {
              kind
              label
              id
            }
            people {
              count
              edges {
                role
                person {
                  __typename
                  id
                  fullName
                  landingPageUrl
                  previews {
                    edges {
                      preview {
                        link
                        kind
                        mediaAsset {
                          files {
                            name
                            path
                            id
                          }
                          topLevelMediaType {
                            kind
                            id
                          }
                          id
                        }
                      }
                    }
                  }
                }
              }
            }
            investmentsBy {
              amount
              link
              deckUrl
              investmentDate
              id
            }
            previews {
              count
              edges {
                cursor
                preview {
                  mediaAsset {
                    id
                    files {
                      id
                      name
                      heightInPixels
                      widthInPixels
                      path
                      status {
                        kind
                        id
                      }
                    }
                    state {
                      kind
                      id
                    }
                    topLevelMediaType {
                      kind
                      id
                    }
                  }
                  kind
                  link
                }
              }
            }
          }
          person {
            __typename
            landingPageUrl
            id
            fullName
            responsibility
            description
            previews {
              count
              edges {
                cursor
                preview {
                  mediaAsset {
                    id
                    files {
                      id
                      name
                      heightInPixels
                      widthInPixels
                      path
                      status {
                        kind
                        id
                      }
                    }
                    state {
                      kind
                      id
                    }
                    topLevelMediaType {
                      kind
                      id
                    }
                  }
                  kind
                  link
                }
              }
            }
          }
        }
        previews {
          count
          edges {
            cursor
            preview {
              mediaAsset {
                id
                files {
                  id
                  name
                  heightInPixels
                  widthInPixels
                  path
                  status {
                    kind
                    id
                  }
                }
                state {
                  kind
                  id
                }
                topLevelMediaType {
                  kind
                  id
                }
              }
              kind
              link
            }
          }
        }
      }
      ... on OriginalContentStory {
        __typename
        id
        revision
        landingPageUrl
        durationInSeconds
        description
        sourceList
        externalId
        subTitle
        title
        label
        link
        lastModified
        moreLikeThis
        badges {
          imageLink
          link
          previews {
            count
            edges {
              cursor
              preview {
                mediaAsset {
                  id
                  files {
                    id
                    name
                    heightInPixels
                    widthInPixels
                    path
                    status {
                      kind
                      id
                    }
                  }
                  state {
                    kind
                    id
                  }
                  topLevelMediaType {
                    kind
                    id
                  }
                }
                kind
                link
              }
            }
          }
          id
        }
        entities {
          description
          id
          name
        }
        mediaItem {
          durationInMilliseconds
          files {
            heightInPixels
            widthInPixels
            name
            path
            id
          }
          topLevelMediaType {
            kind
            id
          }
          id
        }
        people {
          id
          fullName
          responsibility
        }
        peopleEntities {
          entity {
            __typename
            landingPageUrl
            id
            name
            websiteUrl
            industry
            fundingRound
            activities {
              kind
              label
              id
            }
            people {
              count
              edges {
                role
                person {
                  __typename
                  id
                  fullName
                  landingPageUrl
                  previews {
                    edges {
                      preview {
                        link
                        kind
                        mediaAsset {
                          files {
                            name
                            path
                            id
                          }
                          topLevelMediaType {
                            kind
                            id
                          }
                          id
                        }
                      }
                    }
                  }
                }
              }
            }
            investmentsBy {
              amount
              link
              deckUrl
              investmentDate
              id
            }
            previews {
              count
              edges {
                cursor
                preview {
                  mediaAsset {
                    id
                    files {
                      id
                      name
                      heightInPixels
                      widthInPixels
                      path
                      status {
                        kind
                        id
                      }
                    }
                    state {
                      kind
                      id
                    }
                    topLevelMediaType {
                      kind
                      id
                    }
                  }
                  kind
                  link
                }
              }
            }
          }
          person {
            __typename
            landingPageUrl
            id
            fullName
            responsibility
            description
            previews {
              count
              edges {
                cursor
                preview {
                  mediaAsset {
                    id
                    files {
                      id
                      name
                      heightInPixels
                      widthInPixels
                      path
                      status {
                        kind
                        id
                      }
                    }
                    state {
                      kind
                      id
                    }
                    topLevelMediaType {
                      kind
                      id
                    }
                  }
                  kind
                  link
                }
              }
            }
          }
        }
        previews {
          count
          edges {
            cursor
            preview {
              mediaAsset {
                id
                files {
                  id
                  name
                  heightInPixels
                  widthInPixels
                  path
                  status {
                    kind
                    id
                  }
                }
                state {
                  kind
                  id
                }
                topLevelMediaType {
                  kind
                  id
                }
              }
              kind
              link
            }
          }
        }
        origContentTags: tags {
          id
          label
        }
      }
      ... on PodcastStory {
        __typename
        description
        durationInSeconds
        id
        title
        subTitle
        link
        publisher
        landingPageUrl
        previews {
          count
          edges {
            cursor
            preview {
              mediaAsset {
                id
                files {
                  id
                  name
                  heightInPixels
                  widthInPixels
                  path
                  status {
                    kind
                    id
                  }
                }
                state {
                  kind
                  id
                }
                topLevelMediaType {
                  kind
                  id
                }
              }
              kind
              link
            }
          }
        }
        peopleEntities {
          entity {
            __typename
            landingPageUrl
            id
            name
            websiteUrl
            industry
            fundingRound
            activities {
              kind
              label
              id
            }
            people {
              count
              edges {
                role
                person {
                  __typename
                  id
                  fullName
                  landingPageUrl
                  previews {
                    edges {
                      preview {
                        link
                        kind
                        mediaAsset {
                          files {
                            name
                            path
                            id
                          }
                          topLevelMediaType {
                            kind
                            id
                          }
                          id
                        }
                      }
                    }
                  }
                }
              }
            }
            investmentsBy {
              amount
              link
              deckUrl
              investmentDate
              id
            }
            previews {
              count
              edges {
                cursor
                preview {
                  mediaAsset {
                    id
                    files {
                      id
                      name
                      heightInPixels
                      widthInPixels
                      path
                      status {
                        kind
                        id
                      }
                    }
                    state {
                      kind
                      id
                    }
                    topLevelMediaType {
                      kind
                      id
                    }
                  }
                  kind
                  link
                }
              }
            }
          }
          person {
            __typename
            landingPageUrl
            id
            fullName
            responsibility
            description
            previews {
              count
              edges {
                cursor
                preview {
                  mediaAsset {
                    id
                    files {
                      id
                      name
                      heightInPixels
                      widthInPixels
                      path
                      status {
                        kind
                        id
                      }
                    }
                    state {
                      kind
                      id
                    }
                    topLevelMediaType {
                      kind
                      id
                    }
                  }
                  kind
                  link
                }
              }
            }
          }
        }
        revision
        moreLikeThis
      }
      ... on ArticleStory {
        __typename
        description
        id
        link
        subTitle
        title
        publisher
        publishedDate
        timeToReadInSeconds
        revision
        previews {
          count
          edges {
            cursor
            preview {
              mediaAsset {
                id
                files {
                  id
                  name
                  heightInPixels
                  widthInPixels
                  path
                  status {
                    kind
                    id
                  }
                }
                state {
                  kind
                  id
                }
                topLevelMediaType {
                  kind
                  id
                }
              }
              kind
              link
            }
          }
        }
      }
      ... on BookStory {
        __typename
        description
        id
        link
        previews {
          count
          edges {
            cursor
            preview {
              mediaAsset {
                id
                files {
                  id
                  name
                  heightInPixels
                  widthInPixels
                  path
                  status {
                    kind
                    id
                  }
                }
                state {
                  kind
                  id
                }
                topLevelMediaType {
                  kind
                  id
                }
              }
              kind
              link
            }
          }
        }
        subTitle
        title
      }
      ... on NewsletterStory {
        __typename
        description
        link
        id
        previews {
          count
          edges {
            cursor
            preview {
              mediaAsset {
                id
                files {
                  id
                  name
                  heightInPixels
                  widthInPixels
                  path
                  status {
                    kind
                    id
                  }
                }
                state {
                  kind
                  id
                }
                topLevelMediaType {
                  kind
                  id
                }
              }
              kind
              link
            }
          }
        }
        subTitle
        title
        publisher
        publishedDate
        timeToReadInSeconds
      }
      ... on OnlineCourseStory {
        __typename
        description
        id
        link
        cost
        previews {
          count
          edges {
            cursor
            preview {
              mediaAsset {
                id
                files {
                  id
                  name
                  heightInPixels
                  widthInPixels
                  path
                  status {
                    kind
                    id
                  }
                }
                state {
                  kind
                  id
                }
                topLevelMediaType {
                  kind
                  id
                }
              }
              kind
              link
            }
          }
        }
        subTitle
        title
        publishedDate
        timeRequiredInSeconds
        publisher
        revision
      }
      ... on RadivisionPost {
        __typename
        id
        link
        previews {
          count
          edges {
            cursor
            preview {
              mediaAsset {
                id
                files {
                  id
                  name
                  heightInPixels
                  widthInPixels
                  path
                  status {
                    kind
                    id
                  }
                }
                state {
                  kind
                  id
                }
                topLevelMediaType {
                  kind
                  id
                }
              }
              kind
              link
            }
          }
        }
        subTitle
        title
        description
        content
        landingPageUrl
        revision
      }
      ... on Node {
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasErrors",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "errors",
  "storageKey": null,
  "args": null,
  "concreteType": "Error",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "location",
      "args": null,
      "storageKey": null
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "revision",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "subTitle",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isPromoted",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "created",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "label",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isDeleted",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isNew",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "externalId",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "durationInSeconds",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "link",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "trailer",
  "storageKey": null,
  "args": null,
  "concreteType": "PitchVideoDetails",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    (v7/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/)
  ]
},
v19 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "originalClip",
  "storageKey": null,
  "args": null,
  "concreteType": "PitchVideoDetails",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    (v16/*: any*/),
    (v7/*: any*/),
    (v17/*: any*/)
  ]
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "landingPageUrl",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "websiteUrl",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "industry",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fundingRound",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "kind",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "role",
  "args": null,
  "storageKey": null
},
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fullName",
  "args": null,
  "storageKey": null
},
v29 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "path",
  "args": null,
  "storageKey": null
},
v30 = [
  (v25/*: any*/)
],
v31 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "topLevelMediaType",
  "storageKey": null,
  "args": null,
  "concreteType": "TopLevelMediaType",
  "plural": false,
  "selections": (v30/*: any*/)
},
v32 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v33 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "deckUrl",
  "args": null,
  "storageKey": null
},
v34 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "investmentDate",
  "args": null,
  "storageKey": null
},
v35 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v36 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "heightInPixels",
  "args": null,
  "storageKey": null
},
v37 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "widthInPixels",
  "args": null,
  "storageKey": null
},
v38 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": [
    (v26/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PreviewEdge",
      "plural": true,
      "selections": [
        (v35/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "preview",
          "storageKey": null,
          "args": null,
          "concreteType": "Preview",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "mediaAsset",
              "storageKey": null,
              "args": null,
              "concreteType": "MediaAsset",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "files",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MediaAssetFile",
                  "plural": true,
                  "selections": [
                    (v3/*: any*/),
                    (v21/*: any*/),
                    (v36/*: any*/),
                    (v37/*: any*/),
                    (v29/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "status",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "MediaAssetFileStatus",
                      "plural": false,
                      "selections": (v30/*: any*/)
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "state",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MediaAssetState",
                  "plural": false,
                  "selections": (v30/*: any*/)
                },
                (v31/*: any*/)
              ]
            },
            (v25/*: any*/),
            (v17/*: any*/)
          ]
        }
      ]
    }
  ]
},
v39 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "responsibility",
  "args": null,
  "storageKey": null
},
v40 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "peopleEntities",
  "storageKey": null,
  "args": null,
  "concreteType": "EntityPerson",
  "plural": true,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "entity",
      "storageKey": null,
      "args": null,
      "concreteType": "Entity",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        (v20/*: any*/),
        (v3/*: any*/),
        (v21/*: any*/),
        (v22/*: any*/),
        (v23/*: any*/),
        (v24/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "activities",
          "storageKey": null,
          "args": null,
          "concreteType": "EntityActivity",
          "plural": true,
          "selections": [
            (v25/*: any*/),
            (v12/*: any*/)
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "people",
          "storageKey": null,
          "args": null,
          "concreteType": "EntityOwnersConnection",
          "plural": false,
          "selections": [
            (v26/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "EntityOwner",
              "plural": true,
              "selections": [
                (v27/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "person",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Person",
                  "plural": false,
                  "selections": [
                    (v5/*: any*/),
                    (v3/*: any*/),
                    (v28/*: any*/),
                    (v20/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "previews",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "PreviewsConnection",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "edges",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "PreviewEdge",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "preview",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "Preview",
                              "plural": false,
                              "selections": [
                                (v17/*: any*/),
                                (v25/*: any*/),
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "name": "mediaAsset",
                                  "storageKey": null,
                                  "args": null,
                                  "concreteType": "MediaAsset",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "LinkedField",
                                      "alias": null,
                                      "name": "files",
                                      "storageKey": null,
                                      "args": null,
                                      "concreteType": "MediaAssetFile",
                                      "plural": true,
                                      "selections": [
                                        (v21/*: any*/),
                                        (v29/*: any*/)
                                      ]
                                    },
                                    (v31/*: any*/)
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "investmentsBy",
          "storageKey": null,
          "args": null,
          "concreteType": "Investment",
          "plural": true,
          "selections": [
            (v32/*: any*/),
            (v17/*: any*/),
            (v33/*: any*/),
            (v34/*: any*/)
          ]
        },
        (v38/*: any*/)
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "person",
      "storageKey": null,
      "args": null,
      "concreteType": "Person",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        (v20/*: any*/),
        (v3/*: any*/),
        (v28/*: any*/),
        (v39/*: any*/),
        (v7/*: any*/),
        (v38/*: any*/)
      ]
    }
  ]
},
v41 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "sourceList",
  "args": null,
  "storageKey": null
},
v42 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastModified",
  "args": null,
  "storageKey": null
},
v43 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "moreLikeThis",
  "args": null,
  "storageKey": null
},
v44 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "imageLink",
  "args": null,
  "storageKey": null
},
v45 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "entities",
  "storageKey": null,
  "args": null,
  "concreteType": "Entity",
  "plural": true,
  "selections": [
    (v7/*: any*/),
    (v3/*: any*/),
    (v21/*: any*/)
  ]
},
v46 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "durationInMilliseconds",
  "args": null,
  "storageKey": null
},
v47 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "people",
  "storageKey": null,
  "args": null,
  "concreteType": "Person",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v28/*: any*/),
    (v39/*: any*/)
  ]
},
v48 = {
  "kind": "LinkedField",
  "alias": "origContentTags",
  "name": "tags",
  "storageKey": null,
  "args": null,
  "concreteType": "Tag",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v12/*: any*/)
  ]
},
v49 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "publisher",
  "args": null,
  "storageKey": null
},
v50 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "publishedDate",
  "args": null,
  "storageKey": null
},
v51 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "timeToReadInSeconds",
  "args": null,
  "storageKey": null
},
v52 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cost",
  "args": null,
  "storageKey": null
},
v53 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "timeRequiredInSeconds",
  "args": null,
  "storageKey": null
},
v54 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "content",
  "args": null,
  "storageKey": null
},
v55 = [
  (v25/*: any*/),
  (v3/*: any*/)
],
v56 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "topLevelMediaType",
  "storageKey": null,
  "args": null,
  "concreteType": "TopLevelMediaType",
  "plural": false,
  "selections": (v55/*: any*/)
},
v57 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": [
    (v26/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PreviewEdge",
      "plural": true,
      "selections": [
        (v35/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "preview",
          "storageKey": null,
          "args": null,
          "concreteType": "Preview",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "mediaAsset",
              "storageKey": null,
              "args": null,
              "concreteType": "MediaAsset",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "files",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MediaAssetFile",
                  "plural": true,
                  "selections": [
                    (v3/*: any*/),
                    (v21/*: any*/),
                    (v36/*: any*/),
                    (v37/*: any*/),
                    (v29/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "status",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "MediaAssetFileStatus",
                      "plural": false,
                      "selections": (v55/*: any*/)
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "state",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MediaAssetState",
                  "plural": false,
                  "selections": (v55/*: any*/)
                },
                (v56/*: any*/)
              ]
            },
            (v25/*: any*/),
            (v17/*: any*/)
          ]
        }
      ]
    }
  ]
},
v58 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "peopleEntities",
  "storageKey": null,
  "args": null,
  "concreteType": "EntityPerson",
  "plural": true,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "entity",
      "storageKey": null,
      "args": null,
      "concreteType": "Entity",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        (v20/*: any*/),
        (v3/*: any*/),
        (v21/*: any*/),
        (v22/*: any*/),
        (v23/*: any*/),
        (v24/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "activities",
          "storageKey": null,
          "args": null,
          "concreteType": "EntityActivity",
          "plural": true,
          "selections": [
            (v25/*: any*/),
            (v12/*: any*/),
            (v3/*: any*/)
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "people",
          "storageKey": null,
          "args": null,
          "concreteType": "EntityOwnersConnection",
          "plural": false,
          "selections": [
            (v26/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "EntityOwner",
              "plural": true,
              "selections": [
                (v27/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "person",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Person",
                  "plural": false,
                  "selections": [
                    (v5/*: any*/),
                    (v3/*: any*/),
                    (v28/*: any*/),
                    (v20/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "previews",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "PreviewsConnection",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "edges",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "PreviewEdge",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "preview",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "Preview",
                              "plural": false,
                              "selections": [
                                (v17/*: any*/),
                                (v25/*: any*/),
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "name": "mediaAsset",
                                  "storageKey": null,
                                  "args": null,
                                  "concreteType": "MediaAsset",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "LinkedField",
                                      "alias": null,
                                      "name": "files",
                                      "storageKey": null,
                                      "args": null,
                                      "concreteType": "MediaAssetFile",
                                      "plural": true,
                                      "selections": [
                                        (v21/*: any*/),
                                        (v29/*: any*/),
                                        (v3/*: any*/)
                                      ]
                                    },
                                    (v56/*: any*/),
                                    (v3/*: any*/)
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "investmentsBy",
          "storageKey": null,
          "args": null,
          "concreteType": "Investment",
          "plural": true,
          "selections": [
            (v32/*: any*/),
            (v17/*: any*/),
            (v33/*: any*/),
            (v34/*: any*/),
            (v3/*: any*/)
          ]
        },
        (v57/*: any*/)
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "person",
      "storageKey": null,
      "args": null,
      "concreteType": "Person",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        (v20/*: any*/),
        (v3/*: any*/),
        (v28/*: any*/),
        (v39/*: any*/),
        (v7/*: any*/),
        (v57/*: any*/)
      ]
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "storyQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "story",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "StoryPayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "type": "PitchVideoStory",
                "selections": [
                  (v5/*: any*/),
                  (v3/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v40/*: any*/),
                  (v38/*: any*/)
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "OriginalContentStory",
                "selections": [
                  (v5/*: any*/),
                  (v3/*: any*/),
                  (v6/*: any*/),
                  (v20/*: any*/),
                  (v16/*: any*/),
                  (v7/*: any*/),
                  (v41/*: any*/),
                  (v15/*: any*/),
                  (v9/*: any*/),
                  (v8/*: any*/),
                  (v12/*: any*/),
                  (v17/*: any*/),
                  (v42/*: any*/),
                  (v43/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "badges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Badge",
                    "plural": true,
                    "selections": [
                      (v44/*: any*/),
                      (v17/*: any*/),
                      (v38/*: any*/)
                    ]
                  },
                  (v45/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "mediaItem",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MediaAsset",
                    "plural": false,
                    "selections": [
                      (v46/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "files",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "MediaAssetFile",
                        "plural": true,
                        "selections": [
                          (v36/*: any*/),
                          (v37/*: any*/),
                          (v21/*: any*/),
                          (v29/*: any*/)
                        ]
                      },
                      (v31/*: any*/)
                    ]
                  },
                  (v47/*: any*/),
                  (v40/*: any*/),
                  (v38/*: any*/),
                  (v48/*: any*/)
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "PodcastStory",
                "selections": [
                  (v5/*: any*/),
                  (v7/*: any*/),
                  (v16/*: any*/),
                  (v3/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v17/*: any*/),
                  (v49/*: any*/),
                  (v20/*: any*/),
                  (v38/*: any*/),
                  (v40/*: any*/),
                  (v6/*: any*/),
                  (v43/*: any*/)
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "ArticleStory",
                "selections": [
                  (v5/*: any*/),
                  (v7/*: any*/),
                  (v3/*: any*/),
                  (v17/*: any*/),
                  (v9/*: any*/),
                  (v8/*: any*/),
                  (v49/*: any*/),
                  (v50/*: any*/),
                  (v51/*: any*/),
                  (v6/*: any*/),
                  (v38/*: any*/)
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "BookStory",
                "selections": [
                  (v5/*: any*/),
                  (v7/*: any*/),
                  (v3/*: any*/),
                  (v17/*: any*/),
                  (v38/*: any*/),
                  (v9/*: any*/),
                  (v8/*: any*/)
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "NewsletterStory",
                "selections": [
                  (v5/*: any*/),
                  (v7/*: any*/),
                  (v17/*: any*/),
                  (v3/*: any*/),
                  (v38/*: any*/),
                  (v9/*: any*/),
                  (v8/*: any*/),
                  (v49/*: any*/),
                  (v50/*: any*/),
                  (v51/*: any*/)
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "OnlineCourseStory",
                "selections": [
                  (v5/*: any*/),
                  (v7/*: any*/),
                  (v3/*: any*/),
                  (v17/*: any*/),
                  (v52/*: any*/),
                  (v38/*: any*/),
                  (v9/*: any*/),
                  (v8/*: any*/),
                  (v50/*: any*/),
                  (v53/*: any*/),
                  (v49/*: any*/),
                  (v6/*: any*/)
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "RadivisionPost",
                "selections": [
                  (v5/*: any*/),
                  (v3/*: any*/),
                  (v17/*: any*/),
                  (v38/*: any*/),
                  (v9/*: any*/),
                  (v8/*: any*/),
                  (v7/*: any*/),
                  (v54/*: any*/),
                  (v20/*: any*/),
                  (v6/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "storyQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "story",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "StoryPayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "type": "PitchVideoStory",
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v58/*: any*/),
                  (v57/*: any*/)
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "OriginalContentStory",
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v20/*: any*/),
                  (v16/*: any*/),
                  (v7/*: any*/),
                  (v41/*: any*/),
                  (v15/*: any*/),
                  (v9/*: any*/),
                  (v8/*: any*/),
                  (v12/*: any*/),
                  (v17/*: any*/),
                  (v42/*: any*/),
                  (v43/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "badges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Badge",
                    "plural": true,
                    "selections": [
                      (v44/*: any*/),
                      (v17/*: any*/),
                      (v57/*: any*/),
                      (v3/*: any*/)
                    ]
                  },
                  (v45/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "mediaItem",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MediaAsset",
                    "plural": false,
                    "selections": [
                      (v46/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "files",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "MediaAssetFile",
                        "plural": true,
                        "selections": [
                          (v36/*: any*/),
                          (v37/*: any*/),
                          (v21/*: any*/),
                          (v29/*: any*/),
                          (v3/*: any*/)
                        ]
                      },
                      (v56/*: any*/),
                      (v3/*: any*/)
                    ]
                  },
                  (v47/*: any*/),
                  (v58/*: any*/),
                  (v57/*: any*/),
                  (v48/*: any*/)
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "PodcastStory",
                "selections": [
                  (v5/*: any*/),
                  (v7/*: any*/),
                  (v16/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v17/*: any*/),
                  (v49/*: any*/),
                  (v20/*: any*/),
                  (v57/*: any*/),
                  (v58/*: any*/),
                  (v6/*: any*/),
                  (v43/*: any*/)
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "ArticleStory",
                "selections": [
                  (v5/*: any*/),
                  (v7/*: any*/),
                  (v17/*: any*/),
                  (v9/*: any*/),
                  (v8/*: any*/),
                  (v49/*: any*/),
                  (v50/*: any*/),
                  (v51/*: any*/),
                  (v6/*: any*/),
                  (v57/*: any*/)
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "BookStory",
                "selections": [
                  (v5/*: any*/),
                  (v7/*: any*/),
                  (v17/*: any*/),
                  (v57/*: any*/),
                  (v9/*: any*/),
                  (v8/*: any*/)
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "NewsletterStory",
                "selections": [
                  (v5/*: any*/),
                  (v7/*: any*/),
                  (v17/*: any*/),
                  (v57/*: any*/),
                  (v9/*: any*/),
                  (v8/*: any*/),
                  (v49/*: any*/),
                  (v50/*: any*/),
                  (v51/*: any*/)
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "OnlineCourseStory",
                "selections": [
                  (v5/*: any*/),
                  (v7/*: any*/),
                  (v17/*: any*/),
                  (v52/*: any*/),
                  (v57/*: any*/),
                  (v9/*: any*/),
                  (v8/*: any*/),
                  (v50/*: any*/),
                  (v53/*: any*/),
                  (v49/*: any*/),
                  (v6/*: any*/)
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "RadivisionPost",
                "selections": [
                  (v5/*: any*/),
                  (v17/*: any*/),
                  (v57/*: any*/),
                  (v9/*: any*/),
                  (v8/*: any*/),
                  (v7/*: any*/),
                  (v54/*: any*/),
                  (v20/*: any*/),
                  (v6/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "storyQuery",
    "id": null,
    "text": "query storyQuery(\n  $id: ID!\n) {\n  story(id: $id) {\n    hasErrors\n    errors {\n      id\n      location\n    }\n    node {\n      __typename\n      ... on PitchVideoStory {\n        __typename\n        id\n        revision\n        description\n        title\n        subTitle\n        isPromoted\n        created\n        label\n        isDeleted\n        isNew\n        trailer {\n          externalId\n          description\n          durationInSeconds\n          link\n        }\n        originalClip {\n          externalId\n          durationInSeconds\n          description\n          link\n        }\n        peopleEntities {\n          entity {\n            __typename\n            landingPageUrl\n            id\n            name\n            websiteUrl\n            industry\n            fundingRound\n            activities {\n              kind\n              label\n              id\n            }\n            people {\n              count\n              edges {\n                role\n                person {\n                  __typename\n                  id\n                  fullName\n                  landingPageUrl\n                  previews {\n                    edges {\n                      preview {\n                        link\n                        kind\n                        mediaAsset {\n                          files {\n                            name\n                            path\n                            id\n                          }\n                          topLevelMediaType {\n                            kind\n                            id\n                          }\n                          id\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n            investmentsBy {\n              amount\n              link\n              deckUrl\n              investmentDate\n              id\n            }\n            previews {\n              count\n              edges {\n                cursor\n                preview {\n                  mediaAsset {\n                    id\n                    files {\n                      id\n                      name\n                      heightInPixels\n                      widthInPixels\n                      path\n                      status {\n                        kind\n                        id\n                      }\n                    }\n                    state {\n                      kind\n                      id\n                    }\n                    topLevelMediaType {\n                      kind\n                      id\n                    }\n                  }\n                  kind\n                  link\n                }\n              }\n            }\n          }\n          person {\n            __typename\n            landingPageUrl\n            id\n            fullName\n            responsibility\n            description\n            previews {\n              count\n              edges {\n                cursor\n                preview {\n                  mediaAsset {\n                    id\n                    files {\n                      id\n                      name\n                      heightInPixels\n                      widthInPixels\n                      path\n                      status {\n                        kind\n                        id\n                      }\n                    }\n                    state {\n                      kind\n                      id\n                    }\n                    topLevelMediaType {\n                      kind\n                      id\n                    }\n                  }\n                  kind\n                  link\n                }\n              }\n            }\n          }\n        }\n        previews {\n          count\n          edges {\n            cursor\n            preview {\n              mediaAsset {\n                id\n                files {\n                  id\n                  name\n                  heightInPixels\n                  widthInPixels\n                  path\n                  status {\n                    kind\n                    id\n                  }\n                }\n                state {\n                  kind\n                  id\n                }\n                topLevelMediaType {\n                  kind\n                  id\n                }\n              }\n              kind\n              link\n            }\n          }\n        }\n      }\n      ... on OriginalContentStory {\n        __typename\n        id\n        revision\n        landingPageUrl\n        durationInSeconds\n        description\n        sourceList\n        externalId\n        subTitle\n        title\n        label\n        link\n        lastModified\n        moreLikeThis\n        badges {\n          imageLink\n          link\n          previews {\n            count\n            edges {\n              cursor\n              preview {\n                mediaAsset {\n                  id\n                  files {\n                    id\n                    name\n                    heightInPixels\n                    widthInPixels\n                    path\n                    status {\n                      kind\n                      id\n                    }\n                  }\n                  state {\n                    kind\n                    id\n                  }\n                  topLevelMediaType {\n                    kind\n                    id\n                  }\n                }\n                kind\n                link\n              }\n            }\n          }\n          id\n        }\n        entities {\n          description\n          id\n          name\n        }\n        mediaItem {\n          durationInMilliseconds\n          files {\n            heightInPixels\n            widthInPixels\n            name\n            path\n            id\n          }\n          topLevelMediaType {\n            kind\n            id\n          }\n          id\n        }\n        people {\n          id\n          fullName\n          responsibility\n        }\n        peopleEntities {\n          entity {\n            __typename\n            landingPageUrl\n            id\n            name\n            websiteUrl\n            industry\n            fundingRound\n            activities {\n              kind\n              label\n              id\n            }\n            people {\n              count\n              edges {\n                role\n                person {\n                  __typename\n                  id\n                  fullName\n                  landingPageUrl\n                  previews {\n                    edges {\n                      preview {\n                        link\n                        kind\n                        mediaAsset {\n                          files {\n                            name\n                            path\n                            id\n                          }\n                          topLevelMediaType {\n                            kind\n                            id\n                          }\n                          id\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n            investmentsBy {\n              amount\n              link\n              deckUrl\n              investmentDate\n              id\n            }\n            previews {\n              count\n              edges {\n                cursor\n                preview {\n                  mediaAsset {\n                    id\n                    files {\n                      id\n                      name\n                      heightInPixels\n                      widthInPixels\n                      path\n                      status {\n                        kind\n                        id\n                      }\n                    }\n                    state {\n                      kind\n                      id\n                    }\n                    topLevelMediaType {\n                      kind\n                      id\n                    }\n                  }\n                  kind\n                  link\n                }\n              }\n            }\n          }\n          person {\n            __typename\n            landingPageUrl\n            id\n            fullName\n            responsibility\n            description\n            previews {\n              count\n              edges {\n                cursor\n                preview {\n                  mediaAsset {\n                    id\n                    files {\n                      id\n                      name\n                      heightInPixels\n                      widthInPixels\n                      path\n                      status {\n                        kind\n                        id\n                      }\n                    }\n                    state {\n                      kind\n                      id\n                    }\n                    topLevelMediaType {\n                      kind\n                      id\n                    }\n                  }\n                  kind\n                  link\n                }\n              }\n            }\n          }\n        }\n        previews {\n          count\n          edges {\n            cursor\n            preview {\n              mediaAsset {\n                id\n                files {\n                  id\n                  name\n                  heightInPixels\n                  widthInPixels\n                  path\n                  status {\n                    kind\n                    id\n                  }\n                }\n                state {\n                  kind\n                  id\n                }\n                topLevelMediaType {\n                  kind\n                  id\n                }\n              }\n              kind\n              link\n            }\n          }\n        }\n        origContentTags: tags {\n          id\n          label\n        }\n      }\n      ... on PodcastStory {\n        __typename\n        description\n        durationInSeconds\n        id\n        title\n        subTitle\n        link\n        publisher\n        landingPageUrl\n        previews {\n          count\n          edges {\n            cursor\n            preview {\n              mediaAsset {\n                id\n                files {\n                  id\n                  name\n                  heightInPixels\n                  widthInPixels\n                  path\n                  status {\n                    kind\n                    id\n                  }\n                }\n                state {\n                  kind\n                  id\n                }\n                topLevelMediaType {\n                  kind\n                  id\n                }\n              }\n              kind\n              link\n            }\n          }\n        }\n        peopleEntities {\n          entity {\n            __typename\n            landingPageUrl\n            id\n            name\n            websiteUrl\n            industry\n            fundingRound\n            activities {\n              kind\n              label\n              id\n            }\n            people {\n              count\n              edges {\n                role\n                person {\n                  __typename\n                  id\n                  fullName\n                  landingPageUrl\n                  previews {\n                    edges {\n                      preview {\n                        link\n                        kind\n                        mediaAsset {\n                          files {\n                            name\n                            path\n                            id\n                          }\n                          topLevelMediaType {\n                            kind\n                            id\n                          }\n                          id\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n            investmentsBy {\n              amount\n              link\n              deckUrl\n              investmentDate\n              id\n            }\n            previews {\n              count\n              edges {\n                cursor\n                preview {\n                  mediaAsset {\n                    id\n                    files {\n                      id\n                      name\n                      heightInPixels\n                      widthInPixels\n                      path\n                      status {\n                        kind\n                        id\n                      }\n                    }\n                    state {\n                      kind\n                      id\n                    }\n                    topLevelMediaType {\n                      kind\n                      id\n                    }\n                  }\n                  kind\n                  link\n                }\n              }\n            }\n          }\n          person {\n            __typename\n            landingPageUrl\n            id\n            fullName\n            responsibility\n            description\n            previews {\n              count\n              edges {\n                cursor\n                preview {\n                  mediaAsset {\n                    id\n                    files {\n                      id\n                      name\n                      heightInPixels\n                      widthInPixels\n                      path\n                      status {\n                        kind\n                        id\n                      }\n                    }\n                    state {\n                      kind\n                      id\n                    }\n                    topLevelMediaType {\n                      kind\n                      id\n                    }\n                  }\n                  kind\n                  link\n                }\n              }\n            }\n          }\n        }\n        revision\n        moreLikeThis\n      }\n      ... on ArticleStory {\n        __typename\n        description\n        id\n        link\n        subTitle\n        title\n        publisher\n        publishedDate\n        timeToReadInSeconds\n        revision\n        previews {\n          count\n          edges {\n            cursor\n            preview {\n              mediaAsset {\n                id\n                files {\n                  id\n                  name\n                  heightInPixels\n                  widthInPixels\n                  path\n                  status {\n                    kind\n                    id\n                  }\n                }\n                state {\n                  kind\n                  id\n                }\n                topLevelMediaType {\n                  kind\n                  id\n                }\n              }\n              kind\n              link\n            }\n          }\n        }\n      }\n      ... on BookStory {\n        __typename\n        description\n        id\n        link\n        previews {\n          count\n          edges {\n            cursor\n            preview {\n              mediaAsset {\n                id\n                files {\n                  id\n                  name\n                  heightInPixels\n                  widthInPixels\n                  path\n                  status {\n                    kind\n                    id\n                  }\n                }\n                state {\n                  kind\n                  id\n                }\n                topLevelMediaType {\n                  kind\n                  id\n                }\n              }\n              kind\n              link\n            }\n          }\n        }\n        subTitle\n        title\n      }\n      ... on NewsletterStory {\n        __typename\n        description\n        link\n        id\n        previews {\n          count\n          edges {\n            cursor\n            preview {\n              mediaAsset {\n                id\n                files {\n                  id\n                  name\n                  heightInPixels\n                  widthInPixels\n                  path\n                  status {\n                    kind\n                    id\n                  }\n                }\n                state {\n                  kind\n                  id\n                }\n                topLevelMediaType {\n                  kind\n                  id\n                }\n              }\n              kind\n              link\n            }\n          }\n        }\n        subTitle\n        title\n        publisher\n        publishedDate\n        timeToReadInSeconds\n      }\n      ... on OnlineCourseStory {\n        __typename\n        description\n        id\n        link\n        cost\n        previews {\n          count\n          edges {\n            cursor\n            preview {\n              mediaAsset {\n                id\n                files {\n                  id\n                  name\n                  heightInPixels\n                  widthInPixels\n                  path\n                  status {\n                    kind\n                    id\n                  }\n                }\n                state {\n                  kind\n                  id\n                }\n                topLevelMediaType {\n                  kind\n                  id\n                }\n              }\n              kind\n              link\n            }\n          }\n        }\n        subTitle\n        title\n        publishedDate\n        timeRequiredInSeconds\n        publisher\n        revision\n      }\n      ... on RadivisionPost {\n        __typename\n        id\n        link\n        previews {\n          count\n          edges {\n            cursor\n            preview {\n              mediaAsset {\n                id\n                files {\n                  id\n                  name\n                  heightInPixels\n                  widthInPixels\n                  path\n                  status {\n                    kind\n                    id\n                  }\n                }\n                state {\n                  kind\n                  id\n                }\n                topLevelMediaType {\n                  kind\n                  id\n                }\n              }\n              kind\n              link\n            }\n          }\n        }\n        subTitle\n        title\n        description\n        content\n        landingPageUrl\n        revision\n      }\n      ... on Node {\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '34398542fc049c614d860cecd6d942fa';
export default node;
